import { Link } from 'react-router-dom';
import ContentWrapper from '../../views/components/ContentWrapper';
import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { addUser } from '../../data/dataApi';
import { validateEmail } from '../../views/helpers';
import ConfirmationModal from '../../views/components/ConfirmationModal';

const AddUser = () => {
    const [name, setName] = useState();
    const [nameError, setNameError] = useState();
    const [email, setEmail] = useState();
    const [emailError, setEmailError] = useState();
    const [role, setRole] = useState("admin");
    const [unexpectedError, setUnexpectedError] = useState();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const handleSendInvitation = async () => {
        setNameError("");
        setEmailError("");
        setUnexpectedError("");

        if (!name) {
            setNameError("Please enter a name.");
        }

        if (!email) {
            setEmailError("Please enter an email address.");
        }

        if (name && email && validateEmail(email, setEmailError) === "success") {
            const response = await addUser(name, email, role);
            
            if(response.error && response.error.field === "email") {
                setEmailError(response.error.message);
            } else if(response.error) {
                setUnexpectedError(response.error.message);
            } else if(response.success) {
                setShowConfirmationModal(true);
            }
        }
    };
    
    return (
        <>
            <ContentWrapper>
                <div id="user-accounts" className="wrapper">
                    <Link to="/dashboard/user-accounts" className="dashboard-tertiary-btn tif-mb-md-50 tif-mb-25">Back</Link>

                    <Form className="secondary-form">
                        <Form.Group className="form-group tif-mb-md-35 tif-mb-20" controlId="formName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" className={ nameError ? "has-error" : "" } placeholder="Type here" onChange={e => setName(e.target.value)} />
                            { nameError && <p className="error-text">{ nameError }</p> }
                        </Form.Group>

                        <Form.Group className="form-group tif-mb-md-35 tif-mb-20" controlId="formEmail">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control type="email" className={ emailError ? "has-error" : "" } placeholder="Type here" onChange={e => setEmail(e.target.value)} />
                            { emailError && <p className="error-text">{ emailError }</p> }
                        </Form.Group>

                        <Form.Group className="form-group" controlId="formRole">
                            <Form.Label>Role</Form.Label>
                            <Form.Select aria-label="Role" placeholder="Type here" onChange={e => setRole(e.target.value)} size="lg">
                                <option value="admin" selected={ role === "admin" }>Administrator</option>
                                <option value="viewer" selected={ role === "viewer" }>Viewer</option>
                            </Form.Select>
                        </Form.Group>

                        { unexpectedError && <p className="error-text">{ unexpectedError }</p> }

                        <Button className="dashboard-quarternary-btn tif-mt-md-55 tif-mt-30" onClick={ handleSendInvitation }>Send Invitation</Button>
                    </Form>
                </div>
            </ContentWrapper>
            <ConfirmationModal show={ showConfirmationModal } changeVisibility={ setShowConfirmationModal } type="success" successMessage="Invitation has been sent!" close={
                <Link to="/dashboard/user-accounts" className="dashboard-tertiary-btn">Back to User Accounts</Link>
            }/>
        </>
    );
};

export default AddUser;
